"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createShiftTemplate = void 0;
const create_ac_1 = require("../util/create-ac");
const store_1 = __importDefault(require("../../store"));
const util_1 = require("@app/util");
const is_loading_1 = __importDefault(require("../is-loading"));
const shift_template_create_1 = __importDefault(require("@app/request/shift-template-create"));
const load_workspace_detail_1 = __importDefault(require("../load-workspace-detail"));
const hasPosition = (t) => (0, util_1.isDefined)(t.position);
exports.createShiftTemplate = (0, create_ac_1.createAC)(async (dispatch, { data, templateName }) => {
    const { workspaceId } = store_1.default.getState();
    if (!(0, util_1.isValue)(workspaceId))
        return;
    if (!hasPosition(data))
        return;
    dispatch((0, is_loading_1.default)('create-shift-template'));
    const { localityId, ...rest } = data;
    await (0, shift_template_create_1.default)({
        workspace: workspaceId,
        name: templateName,
        data: { ...rest, locality: localityId },
    });
    await dispatch((0, load_workspace_detail_1.default)(workspaceId));
    dispatch((0, is_loading_1.default)('create-shift-template', true));
});
